import { render, staticRenderFns } from "./history-editParticipacion.vue?vue&type=template&id=0cb62f80"
import script from "./history-editParticipacion.vue?vue&type=script&lang=ts"
export * from "./history-editParticipacion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports